import './StatCard.css';

const TREND_CLASS = {
  up:      'sc-val--up',
  down:    'sc-val--down',
  neutral: 'sc-val--neutral',
  accent:  'sc-val--accent',
  warning: 'sc-val--warning',
};

export default function StatCard({ label, value, sub, trend = 'neutral', icon, iconColor, variant = 'default' }) {
  return (
    <div className={`stat-card stat-card--${variant}`}>
      {icon && <div className={`sc-icon${iconColor ? ` sc-icon--${iconColor}` : ''}`}>{icon}</div>}
      <div className="sc-body">
        <div className="sc-label">{label}</div>
        <div className={`sc-val ${TREND_CLASS[trend] ?? 'sc-val--neutral'}`}>{value}</div>
        {sub && <div className="sc-sub">{sub}</div>}
      </div>
    </div>
  );
}
